import React, { useState } from "react";

const money = (v) => (v == null ? "—" : `$${Number(v).toLocaleString()}`);

export const CaseBrowse = ({ alternatives, selectedCount, busy, onAdd }) => {
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState("");
  const [rxOnly, setRxOnly] = useState(false);
  if (!alternatives?.length) return null;
  const full = selectedCount >= 3;
  const rows = alternatives.filter((a) => (!rxOnly || a.offers_rx) && (!q || `${a.plan_name} ${a.carrier} ${a.display_id}`.toLowerCase().includes(q.toLowerCase())));
  return (
    <div className="rounded-xl border border-[#D9D6CC] bg-white p-4" data-testid="case-browse">
      <button type="button" onClick={() => setOpen((o) => !o)} className="min-h-11 w-full text-left text-sm font-semibold text-[#1E3E62]" data-testid="case-browse-toggle">
        {open ? "Hide" : "Browse"} all {alternatives.length} other matching plans for this search
      </button>
      {open && (
        <div className="mt-2 space-y-2">
          {full && <p className="rounded-lg bg-[#FFFBEA] p-2 text-sm text-[#5A4A1A]" data-testid="case-browse-full">The comparison holds 3 plans. Remove one above, then add a plan here to replace it.</p>}
          <div className="flex flex-wrap items-center gap-3">
            <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Filter by name, carrier or plan ID" className="h-11 w-full min-w-0 rounded-lg border border-[#BCCCDC] px-3 text-sm sm:w-auto sm:flex-1" data-testid="case-browse-filter" />
            <label className="flex min-h-11 items-center gap-2 text-sm text-[#33475B]"><input type="checkbox" checked={rxOnly} onChange={(e) => setRxOnly(e.target.checked)} data-testid="case-browse-rx-only" />Includes drug coverage only</label>
          </div>
          <ul className="max-h-[28rem] divide-y divide-[#EEE] overflow-y-auto" data-testid="case-browse-list">
            {rows.map((a) => (
              <li key={a.display_id} className="flex flex-wrap items-center gap-2 py-2" data-testid={`case-browse-row-${a.display_id}`}>
                <div className="min-w-0 flex-1">
                  <p className="text-sm font-semibold text-[#0B192C]">{a.plan_name}</p>
                  <p className="text-xs text-[#5A6B7B]">{a.carrier} · {a.display_id} · {a.plan_type}{a.offers_rx ? " · includes drug coverage" : " · no drug coverage (MA-only)"}</p>
                  <p className="text-xs text-[#5A6B7B]">Premium {money(a.premium)}/mo · Out-of-pocket max {money(a.moop)}{a.part_b_giveback ? ` · Part B reduction ${money(a.part_b_giveback)}/mo` : ""}</p>
                </div>
                <button type="button" disabled={busy || full} onClick={() => onAdd(a.display_id)} className="h-11 rounded-full border border-[#1E3E62] px-4 text-sm font-semibold text-[#1E3E62] disabled:opacity-40" data-testid={`case-browse-add-${a.display_id}`}>Add to comparison</button>
              </li>
            ))}
            {!rows.length && <li className="py-2 text-sm text-[#5A6B7B]">No plans match that filter.</li>}
          </ul>
        </div>
      )}
    </div>
  );
};
